<div class="dialog-main">
    <div class="dialog">
        <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
            <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <div class="contact-content">
            <div>
                <h3>ÚJ TÉTEL HOZZÁADÁSA</h3>
            </div>
            <div class="contact-form">
                <form novalidate [formGroup]="examinationForm!">
                    <div class="field-container">
                        <div class="field">
                            <span>Tétel neve</span>
                            <div class="data">
                                <textarea formControlName="name" id="name" class="form-control" type="text" required
                                    [(ngModel)]="examination.name"></textarea>
                                <!-- <input [(ngModel)]="examination.name" formControlName="name" id="name" class="form-control" type="text" required /> -->
                            </div>
                        </div>
                    </div>
                    @if (!showMinMaxPrice) {
                    <div class="field-container">
                        <div class="field">
                            <span>Tétel ára</span>
                            <div class="data">
                                <input #priceInput id="price" class="form-control" type="number" required
                                    [ngModel]="price" (change)="onChangePrice()" />
                            </div>
                        </div>
                    </div>
                    }

                    @if (!showMinMaxPrice) {
                    <div class="field-container" (click)="showMaxMinPrices()">
                        <div class="field">
                            <div class="min">
                                <button><b>Minimum - maximum ár hozzáadása</b></button>
                            </div>
                        </div>
                    </div>
                    }

                    @if (showMinMaxPrice) {
                    <div class="field-container">
                        <div class="field">
                            <span>Tétel minimum ára</span>
                            <div class="data">
                                <input #minPriceInput id="price" class="form-control" type="number" required
                                    [ngModel]="minPrice" (change)="onChangeMinPrice()" />
                            </div>
                        </div>
                    </div>
                    }

                    @if (showMinMaxPrice) {
                    <div class="field-container">
                        <div class="field">
                            <span>Tétel maximum ára</span>
                            <div class="data">
                                <input #maxPriceInput id="price" class="form-control" type="number" required
                                    [ngModel]="maxPrice" (change)="onChangeMaxPrice()" />
                            </div>
                        </div>
                    </div>
                    }
                    @if (showMinMaxPrice) {
                    <div class="field-container" (click)="showPrice()">
                        <div class="field">
                            <div class="min">
                                <button><b>Minimum - maximum ár elrejtése</b></button>
                            </div>
                        </div>
                    </div>
                    }
                </form>
            </div>
            <div class="field-container" [ngStyle]="{ 'margin-top': '8px' }">
                <div class="field"
                    [ngStyle]="{ 'justify-content': 'center', 'margin-top': '8px', 'margin-bottom': '8px' }">
                    <div class="data" [ngStyle]="{ 'justify-content': 'center' }">
                        <button
                            [ngStyle]="{ background: '#eee', border: '1px solid #0E8388', 'font-weight': 'bold', width: '100%' }"
                            [disabled]="!examinationForm?.valid" (click)="addExamination()">
                            TÉTEL MENTÉSE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>